import { render, staticRenderFns } from "./component-to-objective.vue?vue&type=template&id=7968b50a"
import script from "./component-to-objective.ts?vue&type=script&lang=ts&external"
export * from "./component-to-objective.ts?vue&type=script&lang=ts&external"
import style0 from "./component-to-objective.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports